import StoreLayout from "../../layouts/StoreLayout.vue";
import brand, { pagePath } from "@/brand";

// Info pages live under brand.pagesPath (e.g. /papricka/contact)
const pages = pagePath().slice(1);

export default [
  {
    path: "/",
    component: StoreLayout,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../../views/HomeView.vue"),
        meta: {
          title: `Domov - ${brand.siteName}`,
        },
      },
      {
        path: "products",
        name: "products",
        component: () => import("../../views/products/ProductsView.vue"),
        meta: {
          title: `Produkty - ${brand.siteName}`,
        },
      },
      {
        path: "sets/:slug",
        name: "set-detail",
        component: () => import("../../views/sets/SetDetailView.vue"),
        meta: {
          feature: "productSets",
          title: `Set produktov - ${brand.siteName}`,
        },
      },
      {
        path: "catalogue",
        name: "catalogue",
        redirect: "/products",
        meta: {
          title: `Katalóg - ${brand.siteName}`,
        },
      },
      {
        path: "products/:slug",
        name: "product.detail",
        component: () => import("../../views/products/ProductDetailView.vue"),
        meta: {
          title: `Produkt - ${brand.siteName}`,
          // Switching the size rewrites the URL: don't jump to the top (brands whose page handles it)
          keepScroll: !!brand.productPageKeepsScroll,
        },
      },
      {
        path: "sprievodca/:slug?",
        name: "guide",
        component: () => import("../../views/guide/GuideView.vue"),
        meta: {
          feature: "guide",
          title: `Sprievodca - ${brand.siteName}`,
          // The chat rewrites its own URL: don't jump to the top
          keepScroll: true,
        },
      },
      {
        path: "namiesaj-si",
        name: "mix-builder",
        component: () => import("../../views/MixBuilderView.vue"),
        meta: {
          feature: "mixBuilder",
          title: `Namiešaj si vlastný Delikát - ${brand.siteName}`,
        },
      },
      {
        path: "categories",
        name: "categories",
        component: () => import("../../views/CategoryView.vue"),
        meta: {
          title: `Kategórie - ${brand.siteName}`,
        },
      },
      {
        path: "category/:slug",
        name: "category.detail",
        component: () => import("../../views/CategoryDetailView.vue"),
        meta: {
          title: `Kategória - ${brand.siteName}`,
        },
      },
      {
        path: pages,
        name: "pages",
        redirect: pagePath("contact"),
      },
      {
        path: `${pages}/contact`,
        name: "contact",
        component: () => import("../../views/pages/ContactView.vue"),
        meta: {
          title: `Kontakt - ${brand.siteName}`,
        },
      },
      // {
      //   path: `${pages}/faq`,
      //   name: "faq",
      //   component: () => import("../../views/pages/FAQView.vue"),
      //   meta: {
      //     title: `Časté otázky - ${brand.siteName}`,
      //   },
      // },
      {
        path: `${pages}/privacy`,
        name: "privacy",
        component: () => import("../../views/pages/PrivacyPolicyView.vue"),
        meta: {
          title: `Ochrana osobných údajov - ${brand.siteName}`,
        },
      },
      {
        path: `${pages}/terms`,
        name: "terms",
        component: () => import("../../views/pages/VOPView.vue"),
        meta: {
          title: `Obchodné podmienky - ${brand.siteName}`,
        },
      },
      {
        path: `${pages}/returns`,
        name: "returns",
        component: () => import("../../views/pages/ReturnsView.vue"),
        meta: {
          title: `Reklamačný poriadok - ${brand.siteName}`,
        },
      },
      {
        path: `${pages}/b2b`,
        name: "b2b",
        component: () => import("../../views/pages/B2BView.vue"),
        meta: {
          feature: "b2b",
          title: `B2B Partnerstvo - ${brand.siteName}`,
        },
      },
      {
        path: `${pages}/contest`,
        name: "contest",
        component: () => import("../../views/pages/ContestView.vue"),
        meta: {
          feature: "contest",
          title: `Podmienky súťaže - ${brand.siteName}`,
        },
      },
      {
        path: `${pages}/about`,
        name: "about",
        component: () => import("../../views/pages/AboutView.vue"),
        meta: {
          title: `O nás - ${brand.siteName}`,
        },
      },
    ],
  },
];
